const FOCUSABLE = "input, textarea, select, button, [tabindex]";

/** Whether Tab from `element` leaves `root`: the browser skips what is untabbable, disabled, inert or hidden. */
export function isLastTabStop(root: HTMLElement, element: Element | null): boolean {
  const stops = Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE)).filter(
    (el) =>
      el.tabIndex >= 0 &&
      !el.matches(":disabled") &&
      !el.closest("[inert]") &&
      el.checkVisibility({ checkVisibilityCSS: true }),
  );
  return element !== null && stops.at(-1) === element;
}
